import React from 'react'
import FormErrorMessage from './FormErrorMessage'

interface FormTextareaProps {
  name: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  placeholder?: string
  error?: string
  height?: string
  addClassName?: string
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
  onFocus?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
  maxLength?: number
}

const FormTextarea: React.FC<FormTextareaProps> = ({
  name,
  value,
  onChange,
  placeholder = '',
  error,
  height = 'h-148px',
  addClassName = '',
  onBlur,
  onFocus,
  maxLength,
}) => {
  return (
    <div className={`w-full flex flex-col ${addClassName}`}>
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        placeholder={placeholder}
        maxLength={maxLength}
        className={`
          w-full ${height}
          py-12px px-12px
          border ${
            error
              ? 'border-semanticError focus:border-semanticError'
              : 'border-divider-divider-1 focus:border-brandPrimary'
          }
          rounded-8px
          font-pretendard font-regular text-16px text-textColorText2 leading-180%
          bg-transparent 
          focus:outline-none
          placeholder:text-[#918063]
          resize-none
          scrollbar-hide
        `}
      />
      <FormErrorMessage error={error} />
    </div>
  )
}

export default FormTextarea
